/* ============================================================
   Maui Craft Creations - Scroll Animation Engine
   Uses Intersection Observer API for performance
   ============================================================ */

(function() {
  'use strict';

  var CONFIG = {
    threshold: 0.15,
    rootMargin: '0px 0px -80px 0px'
  };

  // Give every top-level section a consistent reveal, so the whole site
  // animates the same way. Overlay sections (intro bloom, coming soon) are
  // skipped because they run their own entrance animation and wrapping them
  // in a reveal breaks their first paint.
  function initSectionReveals() {
    var sections = document.querySelectorAll(
      '#main-content > .shopify-section, main > .shopify-section'
    );
    sections.forEach(function (section) {
      if (section.querySelector('.mcc-intro, .mcc-coming-soon')) return;
      if (/intro|coming-soon|overlay/i.test(section.id)) return;
      if (section.querySelector(
        '[data-stagger], .scroll-fade, .scroll-slide-up, .scroll-slide-left, .scroll-slide-right, .scroll-scale'
      )) return;
      if (section.matches(
        '.scroll-fade, .scroll-slide-up, .scroll-slide-left, .scroll-slide-right, .scroll-scale'
      )) return;
      section.classList.add('scroll-slide-up');
    });
  }

  function initScrollAnimations() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-visible');
          observer.unobserve(entry.target);
        }
      });
    }, CONFIG);

    var targets = document.querySelectorAll(
      '.scroll-fade, .scroll-slide-up, .scroll-slide-left, .scroll-slide-right, .scroll-scale'
    );
    targets.forEach(function (el) { observer.observe(el); });
  }

  function initStaggerAnimations() {
    var lists = document.querySelectorAll('[data-stagger]');
    lists.forEach(function (list) {
      var children = list.querySelectorAll('[data-stagger-child]');
      children.forEach(function (child, index) {
        child.style.transitionDelay = (index * 0.08) + 's';
        if (!child.classList.contains('scroll-slide-up')) {
          child.classList.add('scroll-slide-up');
        }
      });
    });
  }

  function initParallax() {
    var parallaxElements = document.querySelectorAll('[data-parallax]');
    if (parallaxElements.length === 0) return;
    var ticking = false;
    function update() {
      parallaxElements.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var offset = (window.innerHeight - rect.top) * 0.15;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  function initButtonEnhancements() {
    var buttons = document.querySelectorAll('.mcc-btn, button:not(.mcc-burger)');
    buttons.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () { this.style.willChange = 'transform'; });
      btn.addEventListener('mouseleave', function () { this.style.willChange = 'auto'; });
      btn.addEventListener('click', function (e) {
        var rect = this.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var ripple = document.createElement('span');
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        ripple.style.position = 'absolute';
        ripple.style.width = '20px';
        ripple.style.height = '20px';
        ripple.style.borderRadius = '50%';
        ripple.style.background = 'rgba(255, 255, 255, 0.6)';
        ripple.style.pointerEvents = 'none';
        ripple.style.animation = 'ripple-animation 0.6s ease-out';
        this.style.position = 'relative';
        this.style.overflow = 'hidden';
        this.appendChild(ripple);
        setTimeout(function () { ripple.remove(); }, 600);
      });
    });
  }

  function initSmoothLinks() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initAnimationClasses() {
    var style = document.createElement('style');
    style.textContent = '@keyframes ripple-animation { to { transform: scale(4); opacity: 0; } }';
    document.head.appendChild(style);
  }

  function init() {
    initAnimationClasses();
    initSectionReveals();
    initScrollAnimations();
    initStaggerAnimations();
    initParallax();
    initButtonEnhancements();
    initSmoothLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.reinitScrollAnimations = function () {
    initSectionReveals();
    initScrollAnimations();
    initStaggerAnimations();
  };
})();

/* ============================================================
   Maui Craft Creations - Floating / sticky Add to cart
   (appended) - builds a bottom bar on product pages and
   mirrors the real Add to cart button.
   ============================================================ */
(function () {
  function initStickyAtc() {
    var addBtn = document.querySelector('[data-mcc-add]');
    var form = document.querySelector('[data-mcc-product]');
    if (!addBtn || !form) return; // product pages only
    if (document.querySelector('.mcc-sticky-atc')) return;

    var titleEl = document.querySelector('.mcc-product-title');
    var priceEl = document.querySelector('[data-mcc-price]');

    var bar = document.createElement('div');
    bar.className = 'mcc-sticky-atc';
    bar.innerHTML =
      '<div class="mcc-sticky-atc__info">' +
        '<span class="mcc-sticky-atc__title"></span>' +
        '<span class="mcc-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="mcc-sticky-atc__btn"></button>';
    document.body.appendChild(bar);

    var sTitle = bar.querySelector('.mcc-sticky-atc__title');
    var sPrice = bar.querySelector('.mcc-sticky-atc__price');
    var sBtn = bar.querySelector('.mcc-sticky-atc__btn');
    if (titleEl) sTitle.textContent = titleEl.textContent.trim();

    function sync() {
      if (priceEl) sPrice.textContent = priceEl.textContent.trim();
      sBtn.textContent = (addBtn.textContent || 'Add to cart').trim();
      sBtn.disabled = addBtn.disabled;
    }
    sync();

    sBtn.addEventListener('click', function () {
      if (!addBtn.disabled) addBtn.click();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting;
          bar.classList.toggle('show', show);
          document.body.classList.toggle('mcc-has-sticky-atc', show);
        });
      }, { threshold: 0 });
      io.observe(addBtn);
    }

    var mo = new MutationObserver(sync);
    if (priceEl) mo.observe(priceEl, { childList: true, characterData: true, subtree: true });
    mo.observe(addBtn, { childList: true, attributes: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();

/* ============================================================
   Maui Craft Creations - Header cart icon
   (appended) - adds a cart link with live item count to the
   header bar, replacing the removed bottom floating cart.
   ============================================================ */
(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }
  function initHeaderCart() {
    var nav = document.querySelector('.mcc-nav');
    if (!nav || nav.querySelector('.mcc-header-cart')) return;

    var a = document.createElement('a');
    a.href = root() + 'cart';
    a.className = 'mcc-header-cart';
    a.setAttribute('aria-label', 'View cart');
    a.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
        '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>' +
      '</svg>' +
      '<span class="mcc-header-cart__count" hidden>0</span>';

    var burger = nav.querySelector('.mcc-burger');
    if (burger) { nav.insertBefore(a, burger); } else { nav.appendChild(a); }

    var countEl = a.querySelector('.mcc-header-cart__count');
    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = (c && c.item_count) || 0;
        if (n > 0) { countEl.textContent = n; countEl.hidden = false; }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderCart);
  } else {
    initHeaderCart();
  }
})();
